import { render } from "./price-list.vue?vue&type=template&id=49956e57"
import script from "./price-list.vue?vue&type=script&lang=js"
export * from "./price-list.vue?vue&type=script&lang=js"

import "./price-list.vue?vue&type=style&index=0&id=49956e57&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__